import React from 'react'

function ImportContactsIcon() {
  return (
    <svg
      width="121"
      height="121"
      viewBox="0 0 121 121"
      fill="none"
      className="fill"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M120 60.0089C120 93.1483 93.1306 120 59.9911 120C26.8517 120 0 93.1306 0 60.0089C0 26.8871 26.8694 0 60.0089 0C93.1483 0 120.018 26.8694 120.018 60.0089H120Z"
        className="fill"
        fill="#4A4A4A"
        fillRule="nonzero"
      />
      <path
        d="M64.1818 76.7812C66.5152 75.6875 68.8617 74.8672 71.2216 74.3203C73.5814 73.7734 76.0076 73.5 78.5 73.5C80.4091 73.5 82.2784 73.6563 84.108 73.9688C85.9375 74.2813 87.7803 74.75 89.6364 75.375V44.4375C87.8864 43.7083 86.0701 43.1615 84.1875 42.7969C82.3049 42.4323 80.4091 42.25 78.5 42.25C76.0076 42.25 73.5417 42.5625 71.1023 43.1875C68.6629 43.8125 66.3561 44.75 64.1818 46V76.7812ZM61 86C58.4545 84.0208 55.697 82.4844 52.7273 81.3906C49.7576 80.2969 46.6818 79.75 43.5 79.75C41.2727 79.75 39.0852 80.0365 36.9375 80.6094C34.7898 81.1823 32.7348 81.9896 30.7727 83.0313C29.6591 83.6042 28.5852 83.5781 27.5511 82.9531C26.517 82.3281 26 81.4167 26 80.2188V42.5625C26 41.9896 26.1458 41.4427 26.4375 40.9219C26.7292 40.401 27.1667 40.0104 27.75 39.75C30.1894 38.5 32.7348 37.5625 35.3864 36.9375C38.0379 36.3125 40.7424 36 43.5 36C46.5758 36 49.5852 36.3906 52.5284 37.1719C55.4716 37.9531 58.2955 39.125 61 40.6875C63.7045 39.125 66.5284 37.9531 69.4716 37.1719C72.4148 36.3906 75.4242 36 78.5 36C81.2576 36 83.9621 36.3125 86.6136 36.9375C89.2652 37.5625 91.8106 38.5 94.25 39.75C94.8333 40.0104 95.2708 40.401 95.5625 40.9219C95.8542 41.4427 96 41.9896 96 42.5625V80.2188C96 81.4167 95.483 82.3281 94.4489 82.9531C93.4148 83.5781 92.3409 83.6042 91.2273 83.0313C89.2652 81.9896 87.2102 81.1823 85.0625 80.6094C82.9148 80.0365 80.7273 79.75 78.5 79.75C75.3182 79.75 72.2424 80.2969 69.2727 81.3906C66.303 82.4844 63.5455 84.0208 61 86Z"
        fill="white"
      />
    </svg>
  )
}

export default ImportContactsIcon
